import { render, staticRenderFns } from "./DogLeftBone.vue?vue&type=template&id=041d7e7a&"
import script from "./DogLeftBone.vue?vue&type=script&lang=js&"
export * from "./DogLeftBone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041d7e7a')) {
      api.createRecord('041d7e7a', component.options)
    } else {
      api.reload('041d7e7a', component.options)
    }
    module.hot.accept("./DogLeftBone.vue?vue&type=template&id=041d7e7a&", function () {
      api.rerender('041d7e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Illustrations/DogLeftBone.vue"
export default component.exports